__turbopack_context__.v({
  "donation-widget": "KRamgW_donation-widget",
  "donation-widget__account-info": "KRamgW_donation-widget__account-info",
  "donation-widget__back-button": "KRamgW_donation-widget__back-button",
  "donation-widget__bottom_shade": "KRamgW_donation-widget__bottom_shade",
  "donation-widget__button": "KRamgW_donation-widget__button",
  "donation-widget__checkbox-group": "KRamgW_donation-widget__checkbox-group",
  "donation-widget__checkbox-group__popup": "KRamgW_donation-widget__checkbox-group__popup",
  "donation-widget__checkbox-group__popup-trigger": "KRamgW_donation-widget__checkbox-group__popup-trigger",
  "donation-widget__form": "KRamgW_donation-widget__form",
  "donation-widget__frequency-options": "KRamgW_donation-widget__frequency-options",
  "donation-widget__input-group": "KRamgW_donation-widget__input-group",
  "donation-widget__input-group__suffix": "KRamgW_donation-widget__input-group__suffix",
  "donation-widget__input-group__suggested-sums": "KRamgW_donation-widget__input-group__suggested-sums",
  "donation-widget__input-group__suggested-sums__button": "KRamgW_donation-widget__input-group__suggested-sums__button",
  "donation-widget__input-group__suggested-sums__button--active": "KRamgW_donation-widget__input-group__suggested-sums__button--active",
  "donation-widget__message-sub": "KRamgW_donation-widget__message-sub",
  "donation-widget__pane": "KRamgW_donation-widget__pane",
  "donation-widget__pane--active": "KRamgW_donation-widget__pane--active",
  "donation-widget__pane--entering-backward": "KRamgW_donation-widget__pane--entering-backward",
  "donation-widget__pane--entering-forward": "KRamgW_donation-widget__pane--entering-forward",
  "donation-widget__pane--exiting-backward": "KRamgW_donation-widget__pane--exiting-backward",
  "donation-widget__pane--exiting-forward": "KRamgW_donation-widget__pane--exiting-forward",
  "donation-widget__panes": "KRamgW_donation-widget__panes",
  "donation-widget__payment-option": "KRamgW_donation-widget__payment-option",
  "donation-widget__payment-options": "KRamgW_donation-widget__payment-options",
  "donation-widget__privacy-checkbox-group": "KRamgW_donation-widget__privacy-checkbox-group",
  "donation-widget__privacy-link": "KRamgW_donation-widget__privacy-link",
  "donation-widget__spinner": "KRamgW_donation-widget__spinner",
});
